<template>
  <div>
    <el-dialog
      class="info_driver_modal"
      :append-to-body="true"
      title="Паспорт водителя"
      :visible="dialogVisible"
      :width="isMobile ? '95%' : '60%'"
      :close-on-click-modal="false"
      @open="beforeOpen"
      @close="beforeClose"
    >
      <el-alert v-show="notes" :title="notes" type="error" show-icon />
      <el-row :gutter="24">
        <el-col :xs="24" :sm="12">
          <p>ФИО*</p>
          <el-input
            v-model="driver.fio"
            placeholder="Введите Ваше ФИО"
            :readonly="editDriver.is_approve != 0"
            @input="toCapital"
          />
        </el-col>
        <el-col :xs="24" :sm="12">
          <p>Серия и номер паспорта</p>
          <el-input
            v-model="driver.passport"
            placeholder="Введите серию и номер паспорта (без пробелов)"
            :readonly="editDriver.is_approve != 0"
          />
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :xs="24" :sm="12">
          <p>Водительское удостоверение</p>
          <el-input
            v-model="driver.driver_licence"
            placeholder="Введите номер водительского удостоверения"
            :readonly="editDriver.is_approve != 0"
          />
        </el-col>
        <el-col :xs="24" :sm="12">
          <p>Номер телефона</p>
          <input
            v-model="driver.phone"
            v-mask="'+7 (###) ###-##-##'"
            class="el-input__inner"
            placeholder="Введите номер телефона"
            masked="true"
            :readonly="editDriver.is_approve != 0"
          />
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :xs="24" :sm="12">
          <p>Удостоверение личности</p>
          <upload-document-modal
            ref="uploadDocumentModal"
            name-document="Паспорт водителя"
            :data-edit="documents.driver"
            :source-id="documents.driver.sourceId"
            :need-additional="false"
          />
        </el-col>
      </el-row>
      <set-carrier
        v-if="canAction('action_set_reason')"
        :driver="driver"
        @changed="setCarrier"
      />
      <div>
        <span slot="footer" class="dialog-footer">
          <el-button
            v-if="editDriver.is_approve == 0"
            type="primary"
            @click="updateDriver"
          >
            Сохранить
          </el-button>
          <p v-else>Редактирование контактов принятых водителей запрещено</p>
        </span>
      </div>
      <div v-if="!isMobile">
        <accreditation-wrapper
          v-if="canAction('see_master_approve_wrapper')"
          :entity-id="editDriver.id"
          :link-by-rel="drivers"
          @updateStore="updateStore"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { APPROVEMENTS_DRIVER } from '@/store/actions/approvements'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { capital_letter } from '@/helpers/functions'
import SetCarrier from '@/views/Driver/Forms/SetСarrier'

const Driver = RepositoryFactory.get('driver')

import { filesValidateMixinChildActions } from '@/mixins/filesValidateMixin'
import AccreditationWrapper from '@/components/Accreditation/AccreditationWrapper'
import UploadDocumentModal from '@/components/Upload/UploadDocumentModal'

export default {
  name: 'DriverEdit',
  components: { AccreditationWrapper, UploadDocumentModal, SetCarrier },
  mixins: [filesValidateMixinChildActions],
  props: {
    editDriver: Object,
    dialogVisible: Boolean,
    closeModal: Function,
    currentPerson: Object,
  },
  data() {
    return {
      drivers: 'drivers',

      driver: {
        fio: '',
        driver_licence: '',
        passport: '',
        phone: '',
        carrier_inn: '',
        carrier_name: '',
      },
      documents: {
        driver: {
          sourceModelName: 'drivers',
          sourceId: 0,
          documentType: 'passport',
        },
      },
      source_id: 0,
      notes: '',
      filesValidateMixinData: {
        refComponentName: 'uploadDocumentModal',
        errorMessage: 'удостоверение личности',
        childFilesCountProperty: 'countFiles',
      },
    }
  },
  mounted() {
    this.driver.carrier_inn = this.userInfo.current.organization.inn
    this.driver.carrier_name = this.userInfo.current.organization.short_name
  },
  methods: {
    toCapital(val) {
      this.driver.fio = capital_letter(val)
    },
    updateStore(data) {
      this.$store.dispatch(`drivers/${APPROVEMENTS_DRIVER}`, data)
    },
    beforeOpen() {
      this.source_id = this.editDriver.id
      this.documents.driver.sourceId = this.editDriver.id
      const {
        fio,
        driver_licence,
        passport,
        phone,
        carrier_inn,
        carrier_name,
      } = this.editDriver

      this.driver = {
        fio,
        driver_licence,
        passport,
        phone,
        carrier_inn,
        carrier_name,
      }
    },
    updateDriver() {
      this.checkErrors()

      // if (!this.notes && this.checkCountFilesBeforeSaveInOwn()) {
      if (!this.notes) {
        Driver.updateDriver(this.source_id, this.driver)
          .then(res => {
            if (res.status === 200) {
              this.beforeClose(this.driver)
            }
          })
          .catch(err => {
            if (err.status === 400 && err.data.errors.passport) {
              this.notes = `Значение «Passport» - ${this.driver.passport} уже существует`
            }
          })
      }
    },
    checkErrors() {
      if (!this.driver.fio) {
        this.notes = 'ФИО обязательно для заполнения'
      } else if (!this.driver.passport && !this.driver.driver_licence) {
        this.notes =
          'Необходимо заполнить данные паспорта или водительского удостоверения'
      } else if (
        this.driver.passport.length !== 10 &&
        this.driver.passport.length !== 0
      ) {
        this.notes = 'Значение «Passport» должно содержать 10 символов'
      } else if (!this.driver.carrier_inn) {
        this.notes = 'Необходимо выбрать перевозчика'
      } else {
        this.notes = ''
      }
    },
    setCarrier(data) {
      this.driver.carrier_inn = data.carrier_inn
      this.driver.carrier_name = data.carrier_name
    },
    beforeClose(driver) {
      this.closeModal(driver, this.source_id)
    },
  },
}
</script>

<style lang="sass">
.info_driver_modal
  font-family: "Rubik", sans-serif
  .el-dialog
    margin-top: 3vh !important;
  .el-dialog__body
    padding-top: 0px !important;
  .el-dialog__body
    padding: 0px 20px 40px 20px
</style>
